import { DownloadsConfig } from '../../interfaces/programs.interfaces';

export const NARRATIVE_7TH_GRADE_DOWNLOADS_CONFIG: DownloadsConfig = {
    resourceLink: '/resources/075293a7-61fb-4eea-a236-27d22faa9466',
    headingConfig: {
        letter: 'F',
        grade: 'Grade 7',
        level: 'Level F',
        color: 'var(--program-grade-level-f',
    },
    slideDeckHeading: 'Narrative Writing Slide Decks',
    slideDeckUrl:
        '/program-content/EB Writing Program/Level F/Narrative_Writing_Student_Slide_Decks_ (1).zip',
    digitFilesConfig: [
        {
            value: 'whatIsNarrativeWriting',
            heading: 'What is Narrative Writing?',
            content: [
                {
                    text: 'What is Narrative Writing?',
                    url: 'https://docs.google.com/presentation/d/1UtOQ2oVaGy0xf3_kSEru5F1FdyR6qmA6OBR5kIahscE/copy',
                },
            ],
        },
        {
            value: 'miniLessons',
            heading: 'Mini Lessons',
            content: [
                {
                    text: 'Brainstorming',
                    url: 'https://docs.google.com/presentation/d/1u0mcLw6Tj-mPW44aQtodQ3v0_XYJTtvLc_xYnnz64Zo/copy',
                },
                {
                    text: 'Narrative Writing Quilt',
                    url: 'https://docs.google.com/presentation/d/1tbJoIyn0eognUc9e728NwWbXb7dnpmoMJgiKDVo0r4o/copy',
                },
                {
                    text: 'Understanding POV',
                    url: 'https://docs.google.com/presentation/d/1_aF-pH4QAXyue6OCD5ClYHLIyrXJtOv0KXQ8Ju6bnPs/copy',
                },
                {
                    text: 'Writing Leads',
                    url: 'https://docs.google.com/presentation/d/1HdowtzfCo382pSWQEXdhN0ZrzMgPM-9hLzb28U6WRfA/copy',
                },
                {
                    text: 'Creating Endings',
                    url: 'https://docs.google.com/presentation/d/1lI81fNyoouREa8dBaGV_Ch4v8PUbbNybdoS_Nfrh4l8/copy',
                },
                {
                    text: 'Crafting Stronger Sentences',
                    url: 'https://docs.google.com/presentation/d/1_jHIig4KJkbMhEPiNVm7lP5d7Ld_6K1m0gDNYFBqD2U/copy',
                },
                {
                    text: 'Expanding Sentences',
                    url: 'https://docs.google.com/presentation/d/1K_NMDj8QzpGXJjkzTEw1xlq_oUyDRNLLRWt16JQ2hig/copy',
                },
                {
                    text: 'Dialogue',
                    url: 'https://docs.google.com/presentation/d/1Y8bJ-HvEWRdXGubSkKuf1OSS3s8kpejRfakVx-5LARU/copy',
                },
                {
                    text: 'Transition Words',
                    url: 'https://docs.google.com/presentation/d/1tJVuVL6TeGF5kwk53MIP36-t2DflUPAEdu_2WGLy3Zo/copy',
                },
                {
                    text: 'Story Arc',
                    url: 'https://docs.google.com/presentation/d/11Gkty7AsezQ7x_aQZ1NfalED6Qe7hUUeQqkthvAiXH8/copy',
                },
            ],
        },
        {
            value: 'theWritingProcess',
            heading: 'The Writing Process',
            content: [
                {
                    text: 'All About Figurative Language',
                    url: 'https://docs.google.com/presentation/d/1U1H1epVqX3ddJ5UD2UuHojhI9pUURLn7qlgi1mf6-C8/copy',
                },
                {
                    text: 'Narrative Writing Rubric',
                    url: 'https://docs.google.com/presentation/d/1nUMsFJf5-o8guPaPZRQJIrSJ30fcjO5-E3KgqTqYr44/copy',
                },
                {
                    text: 'Student Checklist',
                    url: 'https://docs.google.com/presentation/d/1795ZVh9AZYGipX7CC9S1qyutjUPdNRJ8LDFq1PGsGAc/copy',
                },
            ],
        },
    ],
};
